module.exports = __webpack_public_path__ + "static/resources@2x-4a87a970f6eb8d18ab7517056fcb65e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/resources@2x.png
// module id = 2697
// module chunks = 157636680307020